<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useDeviceStore } from "../stores/device.js"
const isShow = ref(true)
const clientHeight = ref()
const ContentREF = ref()
const computedClasses = computed(() => ({
  "collapse": true,
  "show": isShow.value
}))

const loaded = ref(false)

const props = defineProps({
  title: String,
  content: String
})

onMounted(() => {
  setTimeout(() => {
    console.log(ContentREF.value.clientHeight)
    clientHeight.value = ContentREF.value.clientHeight
    isShow.value = false
    loaded.value = true
  }, 1000)
})

const changeState = () => isShow.value = !isShow.value
</script>

<template>
  <div :style="{ opacity: loaded ? 1 : 0 }" :class="computedClasses">
    <header @click="changeState">
      <p>Q</p>
      <span><slot name="title">{{props.title}}</slot></span>
      <div class="state">
        <i></i>
        <i></i>
      </div>
    </header>
    <main ref="ContentREF" :style="{ maxHeight: isShow ? `${clientHeight}px` : 0 }">
      <slot>{{ props.content }}</slot>
    </main>
  </div>
</template>
